module.exports = __webpack_public_path__ + "static/img/19.eb397701.gif";